import { CommonModule, NgClass, NgIf } from '@angular/common';
import { ChangeDetectorRef, Component, OnDestroy, OnInit, Renderer2, ViewChild } from '@angular/core';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { ProgressSpinnerComponent } from '@shared/component/progress-spinner/progress-spinner.component';
import { ProgressSpinnerService } from '@shared/services/progress-spinner.service';
import { filter } from 'rxjs';
import { Subject, Subscription, takeUntil } from 'rxjs';

import { MenuService } from './app.menu.service';
import { AppSidebarComponent } from './app.sidebar.component';
import { AppTopbarComponent } from './app.topbar.component';
import { LayoutService } from './service/app.layout.service';
@Component({
  selector: 'app-layout',
  templateUrl: './app.layout.component.html',
  imports: [
    NgClass,
    AppTopbarComponent,
    AppSidebarComponent,
    RouterOutlet,
    NgIf,
    ProgressSpinnerComponent,
    CommonModule
  ],
  providers: [LayoutService]
})
export class AppLayoutComponent implements OnDestroy, OnInit {
  overlayMenuOpenSubscription: Subscription;

  topbarMenuOpenSubscription: Subscription;

  // menuProfileOpenSubscription: Subscription;

  menuOutsideClickListener: any;

  menuScrollListener: any;

  topbarMenuOutsideClickListener: any;

  menuProfileOutsideClickListener: any;
  public styleClass = null;
  isMainPage = false;
  private onComponentDestroy$ = new Subject<void>();

  @ViewChild(AppSidebarComponent) appSidebar!: AppSidebarComponent;

  @ViewChild(AppTopbarComponent) appTopbar!: AppTopbarComponent;

  constructor(
    private menuService: MenuService,
    public layoutService: LayoutService,
    public renderer: Renderer2,
    public router: Router,
    private cd: ChangeDetectorRef,
    private spinner: ProgressSpinnerService
  ) {
    this.hideMenuProfile();

    this.overlayMenuOpenSubscription = this.layoutService.overlayOpen$.subscribe(() => {
      this.hideTopbarMenu();

      if (!this.menuOutsideClickListener) {
        this.menuOutsideClickListener = this.renderer.listen('document', 'click', (event) => {
          const isOutsideClicked = !(
            this.appSidebar.el.nativeElement.isSameNode(event.target) ||
            this.appSidebar.el.nativeElement.contains(event.target) ||
            this.appTopbar.menuButton.nativeElement.isSameNode(event.target) ||
            this.appTopbar.menuButton.nativeElement.contains(event.target)
          );
          if (isOutsideClicked) {
            this.hideMenu();
          }
        });
      }

      if (this.layoutService.isHorizontal() && !this.menuScrollListener) {
        this.menuScrollListener = this.renderer.listen(this.appSidebar.menuContainer.nativeElement, 'scroll', (_) => {
          // if (this.layoutService.isDesktop()) {
          this.hideMenu();
          // }
        });
      }

      if (this.layoutService.state.staticMenuMobileActive) {
        this.blockBodyScroll();
      }
    });

    // this.topbarMenuOpenSubscription =
    //   this.layoutService.topbarMenuOpen$.subscribe(() => {
    //     if (!this.topbarMenuOutsideClickListener) {
    //       this.topbarMenuOutsideClickListener = this.renderer.listen(
    //         'document',
    //         'click',
    //         (event) => {
    //           const isOutsideClicked = !(
    //             this.appTopbar.el.nativeElement.isSameNode(
    //               event.target
    //             ) ||
    //             this.appTopbar.el.nativeElement.contains(
    //               event.target
    //             ) ||
    //             this.appTopbar.mobileMenuButton.nativeElement.isSameNode(
    //               event.target
    //             ) ||
    //             this.appTopbar.mobileMenuButton.nativeElement.contains(
    //               event.target
    //             )
    //           );
    //           if (isOutsideClicked) {
    //             this.hideTopbarMenu();
    //           }
    //         }
    //       );
    //     }

    //     if (this.layoutService.state.staticMenuMobileActive) {
    //       this.blockBodyScroll();
    //     }
    //   });

    // this.menuProfileOpenSubscription =
    //     this.layoutService.menuProfileOpen$.subscribe(() => {
    //         this.hideMenu();
    //
    //         if (!this.menuProfileOutsideClickListener) {
    //             this.menuProfileOutsideClickListener = this.renderer.listen(
    //                 'document',
    //                 'click',
    //                 (event) => {
    //                     const isOutsideClicked = !(
    //                         this.appSidebar.menuProfile.el.nativeElement.isSameNode(
    //                             event.target
    //                         ) ||
    //                         this.appSidebar.menuProfile.el.nativeElement.contains(
    //                             event.target
    //                         )
    //                     );
    //                     if (isOutsideClicked) {
    //                         this.hideMenuProfile();
    //                     }
    //                 }
    //             );
    //         }
    //     });

    // hide menu when click another route
    // this.router.events
    //   .pipe(filter((event) => event instanceof NavigationEnd))
    //   .subscribe(() => {
    // this.hideMenu();
    // this.hideTopbarMenu();
    // this.hideMenuProfile();
    // });
  }
  ngOnInit(): void {
    this.setContainerClass();
    this.isMainPage = this.router.url === '/main';
    this.router.events
      .pipe(
        filter((e) => e instanceof NavigationEnd),
        takeUntil(this.onComponentDestroy$)
      )
      .subscribe((e: NavigationEnd) => {
        this.isMainPage = e.urlAfterRedirects === '/main';
      });
  }

  blockBodyScroll(): void {
    if (document.body.classList) {
      document.body.classList.add('blocked-scroll');
    } else {
      document.body.className += ' blocked-scroll';
    }
  }

  unblockBodyScroll(): void {
    if (document.body.classList) {
      document.body.classList.remove('blocked-scroll');
    } else {
      document.body.className = document.body.className.replace(
        new RegExp('(^|\\b)' + 'blocked-scroll'.split(' ').join('|') + '(\\b|$)', 'gi'),
        ' '
      );
    }
  }

  hideMenu() {
    this.layoutService.state.overlayMenuActive = false;
    // this.layoutService.state.staticMenuMobileActive = false;
    this.layoutService.state.menuHoverActive = false;
    this.menuService.reset();

    if (this.menuOutsideClickListener) {
      this.menuOutsideClickListener();
      this.menuOutsideClickListener = null;
    }

    if (this.menuScrollListener) {
      this.menuScrollListener();
      this.menuScrollListener = null;
    }

    this.layoutService.updatedMenuActiveKey(null);
    this.unblockBodyScroll();
  }

  hideTopbarMenu() {
    this.layoutService.state.topbarMenuActive = false;

    if (this.topbarMenuOutsideClickListener) {
      this.topbarMenuOutsideClickListener();
      this.topbarMenuOutsideClickListener = null;
    }
  }

  hideMenuProfile() {
    this.layoutService.state.menuProfileActive = false;

    if (this.menuProfileOutsideClickListener) {
      this.menuProfileOutsideClickListener();
      this.menuProfileOutsideClickListener = null;
    }
  }

  setContainerClass() {
    this.layoutService.configUpdate$.pipe(takeUntil(this.onComponentDestroy$)).subscribe((config) => {
      if (!config) {
        return;
      }
      const styleClass: { [key: string]: any } = {
        'layout-overlay': config.menuMode === 'overlay',
        'layout-static': config.menuMode === 'static',
        'layout-slim': config.menuMode === 'slim',
        'layout-slim-plus': config.menuMode === 'slim-plus',
        'layout-horizontal': config.menuMode === 'horizontal',
        'layout-reveal': config.menuMode === 'reveal',
        'layout-drawer': config.menuMode === 'drawer',
        'p-input-filled': config.inputStyle === 'filled',
        'p-ripple-disabled': !config.ripple,
        'layout-static-inactive': this.layoutService.state.staticMenuDesktopInactive && config.menuMode === 'static',
        'layout-overlay-active': this.layoutService.state.overlayMenuActive,
        'layout-mobile-active': this.layoutService.state.staticMenuMobileActive,
        'layout-topbar-menu-active': this.layoutService.state.topbarMenuActive,
        'layout-menu-profile-active': this.layoutService.state.menuProfileActive,
        'layout-sidebar-active': this.layoutService.state.sidebarActive,
        'layout-sidebar-anchored': this.layoutService.state.anchored
      };
      styleClass['layout-topbar-' + config.topbarTheme] = true;
      styleClass['layout-menu-' + config.menuTheme] = true;
      styleClass['layout-menu-profile-' + config.menuProfilePosition] = true;

      this.styleClass = styleClass;
    });
  }

  // @HostListener('window:resize')
  // public onWindowResize(): void {
  //   this.hideMenu();
  // }

  ngOnDestroy() {
    if (this.overlayMenuOpenSubscription) {
      this.overlayMenuOpenSubscription.unsubscribe();
    }

    if (this.menuOutsideClickListener) {
      this.menuOutsideClickListener();
    }

    this.onComponentDestroy$.next();
    this.onComponentDestroy$.complete();
  }
}
